import React from 'react'
import { CustomContentModal } from '../../../../components/CustomContentModal'
import AddAccountManagerForm from './AddAccountManagerForm'

interface AddAccountManagerModalProps {
  isOpen: boolean
  onClose: () => void
  tenantAccountCuid: string
}

const AddAccountManagerModal: React.FC<AddAccountManagerModalProps> = ({ isOpen, onClose, tenantAccountCuid }) => {
  if (!isOpen) return null

  return (
    <CustomContentModal isOpen={isOpen} onClose={onClose}>
      <div className="w-full max-w-md rounded-lg bg-white p-6 text-left shadow-xl dark:bg-slate-800">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white">Add a new account manager</h3>
        <p className="mt-1 mb-4 text-sm text-gray-500 dark:text-gray-400">
          Invite by email and copy the account invitation link.
        </p>
        <AddAccountManagerForm
          tenantAccountCuid={tenantAccountCuid}
          onSuccess={onClose}
          onCancel={onClose}
        />
      </div>
    </CustomContentModal>
  )
}

export default AddAccountManagerModal
